module.exports = __webpack_public_path__ + "static/img/NumiResto.8a53c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NumiResto.png
// module id = 31An
// module chunks = 4